import { Pipe, PipeTransform } from '@angular/core';

import { ClienteUnidadeNegocioSearchNaturezaVenda } from '../cliente-unidade-negocio-search-natureza-venda';

@Pipe({
    name: 'clienteUnidadeNegocioNaturezaVendaSituacaoFilter',
    pure: false
})
export class ClienteUnidadeNegocioNaturezaVendaSituacaoFilterPipe implements PipeTransform {
    /** Filtra as naturezas de vendas do cliente pela situação informada */
    transform(entities: ClienteUnidadeNegocioSearchNaturezaVenda[], situacao: number = null): ClienteUnidadeNegocioSearchNaturezaVenda[] {
        if (!entities) {
            return [];
        }
        // Retorna todas as naturezas de vendas quando não for informada uma situação para filtar
        if (!situacao) {
            return entities;
        }

        return entities.filter(entityFilter => entityFilter.situacaoNaturezaVenda === situacao);
    }
}
